import React from 'react';
import { Text, View } from 'react-native';
import { textCtaFont_10_4 } from '../TextComponent/TextStyle';
//= ========================================================================

const LargeBtnWithFilling = ({
  globJSON, simPlatform, inputText, shortBtn, disableBtn, withFlex, marginTop,
}) => {
  const withoutFlex = shortBtn ? 156 : 198;
  return (
    <View style={{
      width: withFlex ? '100%' : withoutFlex,
      padding: 8,
      alignSelf: 'center',
      backgroundColor: disableBtn ? globJSON.configurations.theme.colors.disabled_cta_color : globJSON.configurations.theme.colors.primary_cta_color,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 15,
      marginTop,
    }}
    >
      <Text style={[textCtaFont_10_4(globJSON, simPlatform), { textAlign: 'center' }]}>
        {inputText}
      </Text>
    </View>
  );
};
export default LargeBtnWithFilling;
